import { Typography } from "@mui/material";

import { RowBase, RowChoiceProps } from "./RowBase";
import { WorkListQuestionOption } from "../../../../models/worklist/WorkListQuestionOption";
import { WorkListQuestionType } from "../../../../models/worklist/WorkListQuestionType";

const separator = "__";

const radioYesNoOptions: WorkListQuestionOption[] = [
    {
        value: 0,
        text: "N.V.T.",
    },
    {
        value: 1,
        text: "Ja",
    },
    {
        value: 2,
        text: "Nee",
    },
];

export function RowOptions({ answer }: RowChoiceProps) {
    const options =
        answer.type === WorkListQuestionType.RadioYesNo
            ? radioYesNoOptions
            : answer.options;

    const selected = answer.answer?.split(separator) ?? [];
    const selectedAnswers = options
        .filter(option => selected.includes(option.value.toString()))
        .map(option => option.text)
        .join(", ");

    return (
        <RowBase question={answer.question}>
            <Typography>
                {selectedAnswers.length === 0 ? "-" : selectedAnswers}
            </Typography>
        </RowBase>
    );
}
